import { FileExcelOutlined, FilePdfOutlined, FileZipOutlined, SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Dropdown, Input, Menu, message, Pagination, Popconfirm, Row, Space, Table, Tooltip } from 'antd';
import "jspdf-autotable";
import jsPDF from "jspdf";
import { CSVLink } from "react-csv";
import { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPriorityList, RemovePriorityItems, resetPlanningList } from '../../slices/Planning';
import { ReactComponent as Back } from '../../Images/Back.svg';
import PlanningProduction from '../../Images/productionPlanning.png';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import dayjs from 'dayjs';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { createActivityLog } from '../../slices/activity-log';
import logo from '../../Images/alux-logo.png';

function PriorityList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [orderBy, setOrderBy] = useState('');
    const [pagesize, setPageSize] = useState(100);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const { data = [], status } = useSelector(state => state.Planning);
    const ipAddress = useSelector(state => state.ip.ipAddress);
    const [search, setSearch] = useState(localStorage.getItem('PriorityList') || '');
    const [checkedList, setCheckedList] = useState([
        'SrNo',
        'profile_no',
        'workorder_no',
        'total_pcs',
        'length_mm',
        'total_weight',
        'customer_name',
        'delivery_date',
        'status',
        'added_by',
        'added_at',
        'action',
    ]);

    useEffect(() => {
        dispatch(resetPlanningList());
        dispatch(
            fetchPriorityList({
                page,
                pagesize,
                ...(search && { search: search }),
                ...(orderBy && { ordering: orderBy }),
            }),
        );
    }, [page, pagesize, search, orderBy]);

    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1,
    }));

    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = 'id';

        if (sortField === 'profile_no' && sortOrder === 'ascend') {
            sortingEnumKey = 'profile_no';
        }
        if (sortField === 'profile_no' && sortOrder === 'descend') {
            sortingEnumKey = '-profile_no';
        }
        if (sortField === 'workorder_no' && sortOrder === 'ascend') {
            sortingEnumKey = 'workorder_no';
        }
        if (sortField === 'workorder_no' && sortOrder === 'descend') {
            sortingEnumKey = '-workorder_no';
        }
        if (sortField === 'length_mm' && sortOrder === 'ascend') {
            sortingEnumKey = 'length_mm';
        }
        if (sortField === 'length_mm' && sortOrder === 'descend') {
            sortingEnumKey = '-length_mm';
        }
        if (sortField === 'total_pcs' && sortOrder === 'ascend') {
            sortingEnumKey = 'total_pcs';
        }
        if (sortField === 'total_pcs' && sortOrder === 'descend') {
            sortingEnumKey = '-total_pcs';
        }
        if (sortField === 'total_weight' && sortOrder === 'ascend') {
            sortingEnumKey = 'total_weight';
        }
        if (sortField === 'total_weight' && sortOrder === 'descend') {
            sortingEnumKey = '-total_weight';
        }
        if (sortField === 'customer_name' && sortOrder === 'ascend') {
            sortingEnumKey = 'customer_name';
        }
        if (sortField === 'customer_name' && sortOrder === 'descend') {
            sortingEnumKey = '-customer_name';
        }
        if (sortField === 'delivery_date' && sortOrder === 'ascend') {
            sortingEnumKey = 'delivery_date';
        }
        if (sortField === 'delivery_date' && sortOrder === 'descend') {
            sortingEnumKey = '-delivery_date';
        }
        if (sortField === 'status' && sortOrder === 'ascend') {
            sortingEnumKey = 'status';
        }
        if (sortField === 'status' && sortOrder === 'descend') {
            sortingEnumKey = '-status';
        }
        return sortingEnumKey;
    };
    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.columnKey && sorter.order) {
            const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
            setOrderBy(orderBy);
        }
    };

    const handleCreatePlanning = async (priority_no) => {
        const workorder_detail_id = priority_no?.workorder_detail_id;
        navigate(`/create-planning/${workorder_detail_id}`);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setPage(1);
        setSearch(value);
        localStorage.setItem('PriorityList', value);
    };

    const resetFilter = () => {
        setSearch('');
        setOrderBy(null);
        localStorage.removeItem('PriorityList');
        dispatch(fetchPriorityList({ page: 1, pagesize }));
    };
    const handlePageSizeChange = (current, size) => {
        setPage(1);
        setPageSize(size);
    };

    const handleRemove = (data) => {
        const id = data?.workorder_detail_id;
        if (!id || id === null || id === undefined) {
            message.error('Invalid or missing ID for archiving!');
            return;
        }

        dispatch(RemovePriorityItems({ id }))
            .unwrap()
            .then(() => {
                message.success('Priority remove succesfully!');
                dispatch(fetchAndSetIpAddress());
                dispatch(
                    createActivityLog({
                        action: 'DELETE',
                        module_name: 'Priority List',
                        ip_address: ipAddress,
                        discription: 'Removed workorder no ' + data?.workorder_no + ' from priority list',
                    }),
                );
                dispatch(
                    fetchPriorityList({
                        page,
                        pagesize,
                        ...(search && { search: search }),
                        ...(orderBy && { ordering: orderBy }),
                    }),
                );
            })
            .catch(err => {
                console.error('Archive Error:', err);
                message.error(`Error: ${err || 'Failed to archive the record.'}`);
            });
    };

    const allColumns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            width: 80,
            key: 'SrNo',
            sorter: false,
        },
        {
            title: 'Section No',
            dataIndex: 'profile_no',
            key: 'profile_no',
            sorter: true,
            width: 120,
            render: (text, record) => {
                return <span>{record?.profile?.die_number ?? 'N/A'}</span>;
            },
        },
        {
            title: 'Work Order No',
            dataIndex: 'workorder_no',
            key: 'workorder_no',
            sorter: true,
            width: 180,
            render: (text, record) => {
                return <span>{record?.workorder?.order_no ?? 'N/A'}</span>;
            },
        },
        {
            title: 'Length (mm)',
            dataIndex: 'length_mm',
            key: 'length_mm',
            sorter: true,
            width: 150,
        },
        {
            title: 'Total Pcs',
            dataIndex: 'total_pcs',
            key: 'total_pcs',
            sorter: true,
            width: 120,
        },
        {
            title: 'Total Weight',
            dataIndex: 'total_weight',
            key: 'total_weight',
            sorter: true,
            width: 120,
        },
        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            key: 'customer_name',
            sorter: true,
            width: 200,
        },
        {
            title: 'Delivery Date',
            dataIndex: 'delivery_date',
            key: 'delivery_date',
            sorter: true,
            width: 150,
            render: record => {
                return (
                    <span>
                        {record ? dayjs(record).format('DD-MM-YYYY') : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: true,
            width: 120,
        },
        {
            title: 'Priority Added By',
            dataIndex: 'added_by',
            key: 'added_by',
            width: 170,
            render: record => record || 'N/A',
        },
        {
            title: 'Priority Added At',
            dataIndex: 'added_at',
            key: 'added_at',
            width: 170,
            render: record => {
                return (
                    <span>
                        {record ? dayjs.utc(record).local().format('DD-MM-YYYY HH:mm') : 'N/A'}
                    </span>
                );
            }
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'action',
            fixed: 'right',
            width: 100,
            render: (text, record) => (
                <Space>
                    <>
                        <Tooltip title={'Create Planning'}>
                            <img
                                src={PlanningProduction}
                                alt="Planning Icon"
                                onClick={() => handleCreatePlanning(record)}
                                style={{ width: 25, height: 25, cursor: 'pointer' }}
                            />
                        </Tooltip>
                        <Tooltip title="Remove from priority list">
                            <Popconfirm
                                title="Are you sure you want to archive this record?"
                                onConfirm={() => handleRemove(record)}
                                onCancel={() => message.info('Action cancelled')}
                                okText="Yes"
                                cancelText="No"
                            >
                                <FileZipOutlined style={{ cursor: 'pointer', fontSize: '23px' }} />
                            </Popconfirm>
                        </Tooltip>
                    </>
                </Space>
            ),
        }
    ];

    const handleColumnVisibilityChange = checkedValues => {
        setCheckedList(checkedValues);
    };

    const filteredColumns = useMemo(() => {
        return allColumns.filter(col => checkedList.includes(col.key));
    }, [checkedList]);

    const columnMenu = (
        <Menu className="packagelistdropdown">
            <Menu.Item key="columnMenu">
                <Checkbox.Group
                    value={checkedList}
                    onChange={handleColumnVisibilityChange}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Row>
                        <Col span={12}>
                            <Checkbox value="SrNo" disabled>
                                Sr. No.
                            </Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="profile_no">Section No</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="workorder_no">Workorder No</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="length_mm">Length</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="total_pcs">Total PCS</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="total_weight">Total Weight</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="customer_name">Customer</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="delivery_date">Delivery Date</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="status">Status</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="added_at">Priority Added At</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="added_by">Priority Added By</Checkbox>
                        </Col>
                        <Col span={12}>
                            <Checkbox value="action" disabled>
                                Action
                            </Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
            </Menu.Item>
        </Menu>
    );

    const allCsvColumns = [
        { header: 'Sr. No.', dataKey: 'SrNo', field: 'SrNo' },
        { header: 'Section No', dataKey: 'profile_no', field: 'profile_no' },
        { header: 'WorkOrder No', dataKey: 'workorder_no', field: 'workorder_no' },
        { header: 'Length', dataKey: 'length_mm', field: 'length_mm' },
        { header: 'Total Pcs', dataKey: 'total_pcs', field: 'total_pcs' },
        { header: 'Total Weight', dataKey: 'total_weight', field: 'total_weight' },
        { header: 'Customer Name', dataKey: 'customer_name', field: 'customer_name' },
        { header: 'Delivery Date', dataKey: 'delivery_date', field: 'delivery_date' },
        { header: 'Priority Added At', dataKey: 'added_at', field: 'added_at' },
        { header: 'Priority Added By', dataKey: 'added_by', field: 'added_by' },
        { header: 'Status', dataKey: 'status', field: 'status' },
    ];

    const csvHeaders = allCsvColumns
        .filter(col => checkedList.includes(col.field))
        .map(col => ({
            label: col.header,
            key: col.dataKey
        }));

    const csvListData = dataSource.map((item, index) => {
        const row = {
            SrNo: index + 1
        };

        allCsvColumns
            .filter(col => checkedList.includes(col.field))
            .forEach(col => {
                switch (col.field) {
                    case 'SrNo':
                        row.srNo = item.srNo || 'N/A';
                        break;
                    case 'profile_no':
                        row.profile_no = item?.profile?.die_number || 'N/A';
                        break;
                    case 'workorder_no':
                        row.workorder_no = item?.workorder?.order_no || 'N/A';
                        break;
                    case 'length_mm':
                        row.length_mm = item?.length_mm || 'N/A';
                        break;
                    case 'total_pcs':
                        row.total_pcs = item?.total_pcs || 'N/A';
                        break;
                    case 'total_weight':
                        row.total_weight = item?.total_weight || 'N/A';
                        break;
                    case 'customer_name':
                        row.customer_name = item?.customer_name || 'N/A';
                        break;
                    case 'delivery_date':
                        row.delivery_date = item?.delivery_date || 'N/A';
                        break;
                    case 'status':
                        row.customer_name = item?.customer_name || 'N/A';
                        break;
                    case 'delivery_date':
                        row.delivery_date = item?.delivery_date || 'N/A';
                        break;
                    case 'added_at':
                        row.added_at = dayjs(item?.added_at).format('DD-MM-YYYY HH:mm') || 'N/A';
                        break;
                    case 'added_by':
                        row.added_by = item?.added_by || 'N/A';
                        break;
                    case 'status':
                        row.status = item?.status || 'N/A';
                        break;
                    default:
                        row[col.dataKey] = 'N/A';
                }
            });
        return row;
    });

    const handlePdfDownload = async () => {
        const pdf = new jsPDF("p", "pt", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const pdfColumns = [
            { header: 'Sr. No.', dataKey: 'SrNo', field: 'SrNo' },
            { header: 'Section No', dataKey: 'profile_no', field: 'profile_no' },
            { header: 'WorkOrder No', dataKey: 'workorder_no', field: 'workorder_no' },
            { header: 'Length', dataKey: 'length_mm', field: 'length_mm' },
            { header: 'Total Pcs', dataKey: 'total_pcs', field: 'total_pcs' },
            { header: 'Total Weight', dataKey: 'total_weight', field: 'total_weight' },
            { header: 'Customer Name', dataKey: 'customer_name', field: 'customer_name' },
            { header: 'Delivery Date', dataKey: 'delivery_date', field: 'delivery_date' },
            { header: 'Priority Added At', dataKey: 'added_at', field: 'added_at' },
            { header: 'Priority Added By', dataKey: 'added_by', field: 'added_by' },
            { header: 'Status', dataKey: 'status', field: 'status' },
        ];
        const columns = pdfColumns.filter(col => checkedList.includes(col.field));

        const rows = dataSource.map((item, index) => {
            const row = {
                SrNo: index + 1
            };
            columns.forEach(col => {
                switch (col.field) {
                    case 'SrNo':
                        row.srNo = item.srNo || 'N/A';
                        break;
                    case 'profile_no':
                        row.profile_no = item?.profile?.die_number || 'N/A';
                        break;
                    case 'workorder_no':
                        row.workorder_no = item?.workorder?.order_no || 'N/A';
                        break;
                    case 'length_mm':
                        row.length_mm = item?.length_mm || 'N/A';
                        break;
                    case 'total_pcs':
                        row.total_pcs = item?.total_pcs || 'N/A';
                        break;
                    case 'total_weight':
                        row.total_weight = item?.total_weight || 'N/A';
                        break;
                    case 'customer_name':
                        row.customer_name = item?.customer_name || 'N/A';
                        break;
                    case 'delivery_date':
                        row.delivery_date = item?.delivery_date || 'N/A';
                        break;
                    case 'added_at':
                        row.added_at = dayjs(item?.added_at).format('DD-MM-YYYY HH:mm') || 'N/A';
                        break;
                    case 'added_by':
                        row.added_by = item?.added_by || 'N/A';
                        break;
                    case 'status':
                        row.status = item?.status || 'N/A';
                        break;
                    default:
                        row[col.dataKey] = 'N/A';
                }
            });
            return row;
        });

        pdf.text("Planing Priority Item List", pdf.internal.pageSize.width / 2, 40, { align: "center" });
        pdf.autoTable(columns, rows, {
            startY: 65,
            theme: "grid",
            styles: {
                font: "times",
                halign: "center",
                overflow: 'linebreak',
                cellPadding: 3.5,
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0]
            },
            headStyles: {
                textColor: [0, 0, 0],
                fontStyle: "bold",
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                fillColor: false
            },
            rowStyles: {
                lineWidth: 0.5,
                lineColor: [0, 0, 0]
            },
            tableLineColor: [0, 0, 0],
            rowPageBreak: 'avoid',
            didDrawPage: data => {
                const pageNumber = pdf.internal.getNumberOfPages();
                const str = `Page ${pageNumber}`;
                const dateStr = new Date().toLocaleString();
                pdf.setFontSize(10);
                pdf.text(dateStr, 40, pageHeight - 20);
                pdf.text(str, pageWidth - 60, pageHeight - 20);
                if (pageNumber === 1) {
                    pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);
                }
            },
        });
        pdf.save(`planing_priority_items_list${+new Date()}`);
    };

    const handlePageChange = newPage => {
        setPage(newPage);
        setOrderBy('');
    };

    return (
        <>
            <div className="mainwrap">
                <div className='sticyaction'>
                    <Row className="pagenamerow mb-0" justify="space-between" align="middle">
                        <Col>
                            <h2>Planning Priority Items List</h2>
                            <div className="bredcrumbwrp">
                                <Link onClick={() => navigate(-1)} className="back">
                                    <Back /> BACK
                                </Link>
                                <Breadcrumb
                                    items={[
                                        { title: <Link to="/planning-list">Planning List</Link> },
                                        { title: 'Planning Priority Items List' },
                                    ]}
                                />
                            </div>
                        </Col>
                        <Col>
                            <Space>
                                <Input
                                    placeholder="Search"
                                    className='searchbox'
                                    prefix={<SearchOutlined />}
                                    value={search}
                                    onChange={handleSearch}
                                    style={{ width: '100%' }}
                                />
                                <Tooltip placement="top" title="Reset Filter">
                                    <Button
                                        type="primary"
                                        disabled={!search && !orderBy}
                                        className="iconlink"
                                        onClick={resetFilter}
                                    >
                                        <FilterIcon />
                                    </Button>
                                </Tooltip>
                                <Tooltip placement="top" title={'Export Excel'}>
                                    <Button type="primary" className='iconlink' style={{ width: '10px' }} >
                                        <CSVLink filename={"Priority List.csv"} className='iconlink' style={{ width: '10px' }} data={csvListData} headers={csvHeaders} >
                                            <FileExcelOutlined />
                                        </CSVLink>
                                    </Button>
                                </Tooltip>
                                <Tooltip placement="top" title={'Export PDF'}>
                                    <Button type="primary" className='iconlink' onClick={handlePdfDownload}>
                                        <FilePdfOutlined />
                                    </Button>
                                </Tooltip>
                                <Link>
                                    <Tooltip placement="topLeft" title="Column Filter Options">
                                        <Dropdown
                                            overlay={columnMenu}
                                            trigger={['click']}
                                            placement="bottomRight"
                                            open={dropdownVisible}
                                            onOpenChange={setDropdownVisible}
                                        >
                                            <Button
                                                type="primary"
                                                icon={<ColumnList />}
                                                onClick={e => e.preventDefault()}
                                            />
                                        </Dropdown>
                                    </Tooltip>
                                </Link>
                            </Space>
                        </Col>
                    </Row>
                </div>


                <div className="tablewrp">
                    <Table
                        rowKey="id"
                        columns={filteredColumns}
                        dataSource={dataSource}
                        pagination={false}
                        loading={status === 'loading'}
                        scroll={{ x: '600px' }}
                        onChange={handleTableChange}
                    />
                </div>

                <Pagination
                    current={page}
                    pageSize={pagesize}
                    total={dataSource?.length}
                    showSizeChanger
                    onShowSizeChange={handlePageSizeChange}
                    pageSizeOptions={['20', '50', '100']}
                    showTotal={total => `Total ${total} items`}
                    onChange={handlePageChange}
                    locale={{ items_per_page: 'Items / Page' }}
                />
            </div >
        </>
    );
}

export default PriorityList;